import { v2_actionEnviarAudioBuffer } from 'src/services/api/index';
import { initCacheFileSave, getImageBlob, removeMessageFromIDB } from './cache.helper';
import { toast } from 'src/@/components/ui/use-toast';

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const saveAudioToCache = async (messageId, audioBlob) => {
  try {
    await initCacheFileSave(messageId, audioBlob, 'audio/ogg');
    return true;
  } catch (error) {
    console.error('Erro ao salvar áudio em cache:', error);
    return false;
  }
};

export const getAudioFromCache = async (messageId) => {
  try {
    const audioBlob = await getImageBlob(messageId);
    return audioBlob;
  } catch (error) {
    console.error('Erro ao recuperar áudio do cache:', error);
    return null;
  }
};

export const prepareAudioForResend = async (message) => {
  if (message.type === 'audio' || message.type === 'ptt') {
    const cachedAudio = await getAudioFromCache(message.id);
    if (cachedAudio) {
      return cachedAudio
    }
  }
  return message;
}; 


export const resendAudio = async (messageId, chat, blob) => {
  if (chat.canal === "whatsapp") {
    try {
      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("filename", filename);
      formData.append("file", blob);
      formData.append("phone", chat.numeroCliente);
      let querys = `?sessao=${chat.sessao}&canal=${chat.canal}`;
      await v2_actionEnviarAudioBuffer(querys, formData);
      await removeMessageFromIDB('error_msg_send', messageId)
    } catch (err) {
      toast({
        variant: 'destructive',
        description: 'Erro ao enviar',
        });

    }

  }
}